import { gql } from "graphql-request";

export const PRODUCT_CERTS = gql`
  query ProductCerts($clientId: ID!, $pageNo: Int, $pageSize: Int) {
    productCerts(clientId: $clientId, pageNo: $pageNo, pageSize: $pageSize) {
      data {
        _id
        fileName
        uploadDate
        itemCount
        companyName
        formType
      }
      meta {
        countDocs
        pageNo
        pageSize
      }
    }
  }
`;

export const PRODUCT_CERT = gql`
  query ProductCert($id: ID!) {
    productCert(id: $id) {
      data {
        _id
        fileName
        uploadDate
        itemCount
        companyName
        formType
        extractedData {
          certifier
          certifierDetails {
            yourName
            title
            companyName
            address
            countryAndPostalCode
            phone
            email
          }
          exporterDetails {
            companyName
            address
            countryAndPostalCode
            phone
            email
          }
          producerDetails {
            companyName
            address
            countryAndPostalCode
            phone
            email
          }
          importerDetails {
            companyName
            address
            countryAndPostalCode
            phone
            email
          }
          items {
            partNumber
            description
            hts
            invoiceNumber
            originCriterion
            order
            ship
            net
            amount
            origin
            qtyPerPallet
            INCLUDED
          }
        }
      }
    }
  }
`;

export const DELETE_PRODUCT_CERT = gql`
  mutation DeleteProductCert($id: ID!) {
    deleteProductCert(id: $id) {
      data
    }
  }
`;

export const PROCESS_FILE_FOR_PRODUCT_CERT_WITH_CLIENT = gql`
  mutation ProcessFileForProductCert($fileUrl: String!, $fileName: String!, $clientId: ID!, $tenantId: ID, $formType: String!) {
    processFileForProductCert(fileUrl: $fileUrl, fileName: $fileName, clientId: $clientId, tenantId: $tenantId, formType: $formType) {
      success
      certificateId
      data {
        certifier
        certifierDetails {
          yourName
          title
          companyName
          address
          countryAndPostalCode
          phone
          email
        }
        exporterDetails {
          companyName
          address
          countryAndPostalCode
          phone
          email
        }
        producerDetails {
          companyName
          address
          countryAndPostalCode
          phone
          email
        }
        importerDetails {
          companyName
          address
          countryAndPostalCode
          phone
          email
        }
        items {
          partNumber
          description
          hts
          invoiceNumber
          originCriterion
          order
          ship
          net
          amount
          origin
          qtyPerPallet
          INCLUDED
        }
      }
      message
    }
  }
`;

export const UPDATE_PRODUCT_CERT_EXTRACTED_DATA = gql`
  mutation UpdateProductCertExtractedData($id: ID!, $extractedData: UpdateExtractedDataInput!) {
    updateProductCertExtractedData(id: $id, extractedData: $extractedData) {
      data {
        _id
        extractedData {
        certifier
        certifierDetails {
          yourName
          title
          companyName
          address
          countryAndPostalCode
          phone
          email
        }
        exporterDetails {
          companyName
          address
          countryAndPostalCode
          phone
          email
        }
        producerDetails {
          companyName
          address
          countryAndPostalCode
          phone
          email
        }
        importerDetails {
          companyName
          address
          countryAndPostalCode
          phone
          email
        }
        items {
          partNumber
          description
          hts
          invoiceNumber
          originCriterion
          order
          ship
          net
          amount
          origin
          qtyPerPallet
          INCLUDED
        }
      }
      }
    }
  }
`;